import { Box, Divider, Typography, Grid, useTheme } from "@mui/material";
import Player from "./player-item";
import Glass from "../glass/glass";
import { useSelector } from 'react-redux';
import type {LobbyPlayer, RootState} from '../../types/store';
import AppUtils from '../../utils/app-utils';

type TeamContainerProps = {
    isAdmin: boolean;
    onKick: (nickname:string) => void;
    players: LobbyPlayer[];
    me: string;
};

export default function TeamContainer({ isAdmin, onKick, players, me }: TeamContainerProps) {
    const theme = useTheme();
    const translate = useSelector((state:RootState) => state.ui.language.lobby);
    const lobby = useSelector((state:RootState) => state.page.lobby);
    const isTV = !lobby.playing;
    
    let hasHost = 0;
    players.forEach((v) => {
        if(v.nickname.toLowerCase() == "host") hasHost = 1;
    });
    
    let header_text = translate.teamHeader;
    
    let player_count = AppUtils.replaceLanguage(translate.players, { "%p": players.length-hasHost });
    return (
        <Glass sx={{ borderRadius: 1, display: 'flex', flexDirection: 'column' }}>
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"} borderRadius={1}
                color={theme.palette.primary.light} bgcolor={theme.palette.secondary.dark} padding={isTV ? 0.75 : 1} flexShrink={0}>
                <Typography fontSize={isTV ? "1.1rem" : "1.25rem"}>{header_text}</Typography>
            </Box>
            <Grid 
                container 
                padding={isTV ? 1.5 : 2} 
                spacing={isTV ? 1 : 2}
                sx={{
                    overflowY: 'auto',
                    maxHeight: isTV ? 'calc(100dvh - 210px)' : 'none',
                    scrollbarWidth: 'thin',
                    scrollbarColor: '#7dabd0ff rgba(255,255,255,0.1)',
                    '&::-webkit-scrollbar': { width: '8px' },
                    '&::-webkit-scrollbar-thumb': { background: '#7dabd0ff', borderRadius: '4px' },
                    '&::-webkit-scrollbar-track': { background: 'rgba(255,255,255,0.1)' },
                }}
            >
                {players.map((player, i) => (player.nickname.toLowerCase() != "host" && 
                    <Grid key={i} size={{ xs: 6, sm: 6, md: 4, lg: 4, xl: 3 }} height={isTV ? 42 : 50}>
                        <Player player={player.nickname} isAdmin={isAdmin} onKick={onKick} me={me} />
                        <Divider />
                    </Grid>
                ))}
            </Grid>
            <Box display={"flex"} alignItems={"center"} justifyContent={"center"} borderRadius={1}
                color={theme.palette.primary.light} bgcolor={theme.palette.secondary.dark} padding={isTV ? 0.75 : 1} flexShrink={0}>
                <Typography fontSize={isTV ? "1.1rem" : "1.25rem"}>{player_count}</Typography>
            </Box>
        </Glass>
    );
}
